import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16b07377"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b07377')) {
      api.createRecord('16b07377', component.options)
    } else {
      api.reload('16b07377', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=16b07377", function () {
      api.rerender('16b07377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Address/index.vue"
export default component.exports